import 'antd/dist/reset.css'

import { FlagsmithProvider } from '@flagsmith/flagsmith/react'
import { NotificationsContextProvider } from '@notification/contexts'
import { OpenAPI } from '@organization/api/requests'
import { ConfigProvider } from '@organization/components'
import { flagsmith, flagsmithOptions } from '@organization/flagsmith'
import { SessionContextProvider } from '@organization/provider'
import { QueryClientProvider } from '@organization/QueryClientProvider'
import { Global } from '@organization/styles'
import { WizardProvider } from '@organization/wizard'
import { getLocalStorageTokens } from '@shared/utils/getToken'
import { App as BaseAntdApp } from 'antd'

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { I18nextProvider } from 'react-i18next'

import { BrowserRouter } from 'react-router-dom'

import { organizationI18n } from './i18n'
import { Router } from './router'

OpenAPI.TOKEN = getLocalStorageTokens().access ?? undefined

const RECAPTCHA_SITE_KEY = import.meta.env.VITE_APP_RECAPTCHA_KEY ?? ''

const App = () => {
  return (
    <BrowserRouter>
      <FlagsmithProvider flagsmith={flagsmith} options={flagsmithOptions}>
        <ConfigProvider>
          <BaseAntdApp>
            <QueryClientProvider>
              <I18nextProvider i18n={organizationI18n} defaultNS="organization">
                <GoogleReCaptchaProvider
                  reCaptchaKey={RECAPTCHA_SITE_KEY}
                  scriptProps={{ async: true, defer: true }}
                >
                  <SessionContextProvider>
                    <WizardProvider>
                      <NotificationsContextProvider>
                        <Global />
                        <Router />
                      </NotificationsContextProvider>
                    </WizardProvider>
                  </SessionContextProvider>
                </GoogleReCaptchaProvider>
              </I18nextProvider>
            </QueryClientProvider>
          </BaseAntdApp>
        </ConfigProvider>
      </FlagsmithProvider>
    </BrowserRouter>
  )
}

export default App
